export const Constants = {
  technogymStaff_roleId: 'db861299-e18d-4d29-be64-02d675c98a25'
}
